import { useEffect } from "react";
import useLang from "../../../hooks/useLang";
import useAnalysisData from "./useAnalysisData";
import Loader from "../../../components/Loader";

const useStepThree = ({ isNavigating, analysisId, setAnalysisId }) => {
  const lang = useLang();
  const { analysis, analysisLoading } = useAnalysisData({
    analysisId,
    setAnalysisId,
  });

  const items = [];
  items.push({
    id: "state",
    value: lang(`reports.${analysis?.data?.report?.state}`),
  });
  if (analysis?.data?.report?.filename && analysis?.data?.report?.url) {
    items.push({
      id: "report",
      label: lang("reports.report"),
      value: analysis?.data?.report?.filename,
      link: analysis?.data?.report?.url,
    });
  }

  const stepThreeArticles =
    isNavigating || analysisLoading
      ? [<Loader small />]
      : [
          {
            items,
          },
        ];

  useEffect(() => {
    if (analysis?.data?.report?.state !== "GENERATING") return;
    if (typeof analysis?.refetch !== "function") return;

    const interval = setInterval(() => {
      analysis?.refetch?.();
    }, 5000);
    return () => clearInterval(interval); // cleanup
    // eslint-disable-next-line
  }, [analysis?.data?.report?.state]);

  return { stepThreeArticles };
};

export default useStepThree;
